import React, { useEffect, useRef, useState } from "react";
import { StyleSheet, Text, TouchableHighlight } from "react-native";
import { widthPercentageToDP } from "react-native-responsive-screen";
import { Colors, globalStyles, webTextPercent } from "../global";

export default function StyledButton({
  title,
  onPress,
  linkTo = false,
  gray = false,
  small = false,
  style = {},
  textProps = {},
  ...props
}) {
  const buttonRef = useRef();
  const [hovered, setHovered] = useState(false);

  useEffect(() => {
    if (buttonRef.current) {
      const domNode = buttonRef.current;
      const handleHover = () => setHovered(true);
      const handleHoverOut = () => setHovered(false);

      domNode.addEventListener("mouseenter", handleHover);
      domNode.addEventListener("mouseleave", handleHoverOut);

      return () => {
        domNode.removeEventListener("mouseenter", handleHover);
        domNode.removeEventListener("mouseleave", handleHoverOut);
      };
    }
  }, [buttonRef, buttonRef.current]);

  let styleObj = {};
  let styleArray = [{}];
  if (Array.isArray(style)) {
    styleArray = style;
  } else if (typeof style == "object") {
    styleObj = style;
  }

  const isLink = typeof linkTo === "string";
  const linkProps = {
    accessibilityRole: "link",
    href: linkTo,
    onPress: (event) => {
      //Prevents button from redirecting twice due to onPress + href
      //Navigating from href causes page to refresh, so we avoid it
      event.preventDefault();
      onPress();
    },
  };

  return (
    <TouchableHighlight
      ref={buttonRef}
      style={[
        styles.baseButton,
        globalStyles.dropShadow,
        gray && styles.grayBackground,
        small && styles.smallButton,
        hovered && styles.hovered,
        styleObj,
      ].concat(styleArray)}
      onPress={onPress}
      underlayColor={gray ? Colors.greyHighlight : Colors.burgundyHighlight}
      {...(isLink && linkProps)}
      {...props}
    >
      <Text style={styles.baseLabel} {...textProps}>
        {title}
      </Text>
    </TouchableHighlight>
  );
}

const styles = StyleSheet.create({
  baseButton: {
    alignItems: "center",
    justifyContent: "center",
    marginVertical: 5,
    backgroundColor: Colors.burgundy,
    paddingHorizontal: 10,
    minWidth: 265,
    height: widthPercentageToDP(webTextPercent) * 3,
    borderRadius: (widthPercentageToDP(webTextPercent) * 3) / 2,
  },
  hovered: {
    borderWidth: 3,
  },
  baseLabel: {
    color: Colors.white,
    fontSize: widthPercentageToDP(webTextPercent),
    fontFamily: "Cairo",
  },
  grayBackground: {
    backgroundColor: Colors.grey,
  },
  smallButton: {
    minWidth: 120,
    height: widthPercentageToDP(webTextPercent) * 2.5,
    borderRadius: (widthPercentageToDP(webTextPercent) * 2.5) / 2,
  },
});
